import { combineReducers } from 'redux';

import { tvPanelReducer } from './containers/Tvpanel/reducer';

export const tvPanelModuleReducer = combineReducers({
  tvPanelReducer,
});

export type TvPanelModuleState = ReturnType<typeof tvPanelModuleReducer>;
